module.exports = __webpack_public_path__ + "img/20200506145105289.fa06b942.png";